import axios from './axios';

export const getEmails = ({ params } = {}) => axios.get(`emails`, { params });
export const getEmail = ({id, params }) => axios.get(`emails/${id}`, { params });

export const createEmail = ({ data }) => axios.post('emails', data)
//export const deleteEmail = ({ id }) => axios.delete(`settings/${id}`)
export const findEmail = ({ params, id } = {}) => axios.get(`emails/${id}`, { params })
export const updateEmail = ({ id, data }) => axios.put(`emails/${id}`, data)

// Email Conversation APIs
export const getConversation = (id) => axios.get(`emails/${id}/conversation`)
export const getReplies = (id) => axios.get(`emails/${id}/replies`)
export const sendReply = ({ id, data }) => axios.post(`emails/${id}/reply`, data)
export const sendEmailNow = (id) => axios.post(`emails/${id}/send-now`)
